import { createAction, handleActions } from 'redux-actions';

// ACTION CREATORS
export const getLogin = createAction('GET_LOGIN');
export const setLogin = createAction('SET_LOGIN');
export const createSession = createAction('CREATE_SESSION');
export const getCurrentUser = createAction('GET_CURRENT_USER');

// REDUCERS
export const reducer = handleActions(
  new Map([
    [
        setLogin,
      (state, action) => {
        return action.payload
      } 
    ]
  ]),
  {
    isLoggedIn: false,
    username: null,
    user_groups: [],
    application_name: null
  }
);

// SELECTORS
export const getUserState = state => state.user;
export const getLoginState = state => state.login;
export const isAdmin = state => {
  const login = state.login;
  return login && login.user_groups && login.user_groups.includes('MMT Groups::insurance-ruleEngine-admin');
};
 
